import { useEffect, useState } from 'react'
import { useFormikContext } from 'formik'

import { EMPTY_LIST } from '../../../../../../constants/common'
import { PAGINATION_ALL_ITEMS_SIZE } from '../../../../../../constants/pagination'
import { useNotification } from '../../../../../../hooks'
import { getTaskType } from '../../../../Task.api'
import { TASK_FORM_TYPE_FIELD_NAME } from '../../../TaskForm.constants'

import { getValidItems } from './useTypeFieldLoad.utils'

export function useTypeFieldLoad() {
  const { values } = useFormikContext()

  const { handleAddErrorNotification } = useNotification()

  const [isLoading, setLoading] = useState(true)
  const [items, setItems] = useState(EMPTY_LIST)

  useEffect(() => {
    getTaskType({ page_size: PAGINATION_ALL_ITEMS_SIZE })
      .then(({ data }) => {
        setItems(
          getValidItems(data.results.objects, values[TASK_FORM_TYPE_FIELD_NAME])
        )
      })
      .catch(() => {
        handleAddErrorNotification('Error.CommonApiRequestFailKey')
      })
      .finally(() => {
        setLoading(false)
      })
  }, [])

  return { isLoading, items }
}
